import Joi from 'joi';
import type {
  IActionCreator,
  IAnyAction,
  ITopicBoundActionCreator,
} from '../helpers';

const creators = new Set<IActionCreator | ITopicBoundActionCreator>();
const map = new Map<string, Joi.ObjectSchema>();

export function actionSchemaByType(type: string): Joi.ObjectSchema | null {
  return map.get(type) || null;
}

export function allActionCreators(): Array<
  | IActionCreator<IAnyAction, unknown[]>
  | ITopicBoundActionCreator<IAnyAction, string, unknown[]>
> {
  return [...creators];
}

function registerActionCreator(
  creator: IActionCreator | ITopicBoundActionCreator
): void {
  const existing = map.get(creator.type);
  if (existing && existing !== creator.schema) {
    throw new Error(`The schema registry already has type ${creator.type}`);
  }
  creators.add(creator);
  map.set(creator.type, creator.schema);
}

export function registerAllActions(moduleRaw: { [key: string]: {} }): void {
  const module = moduleRaw as { [key: string]: ITopicBoundActionCreator };
  const keys = Object.keys(module);

  keys
    .filter(
      (key) =>
        typeof module[key] === 'function' &&
        typeof module[key].type === 'string' &&
        Joi.isSchema(module[key].schema)
    )
    .map((key) => {
      return { creator: module[key] };
    })
    .forEach((info) => registerActionCreator(info.creator));
}

export function getAllRegisteredActionTypes(): string[] {
  return Array.from(map.keys());
}
